import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	filterDetails: {
		id: 'issue-navigator-custom-filters.details-popup.filter-details',
		defaultMessage: 'Filter details',
		description: 'Text of button that opens the filter details popup',
	},
});
